"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRouteConfigFromResellerNavigationItems = void 0;
const ResellerAreaContentPage_1 = __importDefault(require("../components/pages/ResellerAreaContentPage"));
const Paths_1 = require("../constants/Paths");
const createRouteConfigFromResellerNavigationItems = (items) => {
    const mapResellerNavigationItem = (item) => ({
        path: `${Paths_1.PATH_RESELLER}${item.pathname}`,
        exact: true,
        component: ResellerAreaContentPage_1.default,
        routes: (item.children ?? []).map(mapResellerNavigationItem),
        resellerNavigationItem: item,
        tabNavigationLabel: item.title ?? '',
    });
    return items.map(mapResellerNavigationItem);
};
exports.createRouteConfigFromResellerNavigationItems = createRouteConfigFromResellerNavigationItems;
